<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import ShareListingButton from 'dashboard/components-next/ShareListingButton.vue';
import LaisFavoriteButton from 'dashboard/components-next/lais/LaisFavoriteButton.vue';
import LaisListingCtaMatrix from 'dashboard/components-next/lais/LaisListingCtaMatrix.vue';

defineProps({
  imovel: {
    type: Object,
    default: () => ({}),
  },
  reportLink: {
    type: String,
    default: '',
  },
  contactId: {
    type: Number,
    default: null,
  },
  businessContext: {
    type: String,
    default: '',
  },
  favorited: {
    type: Boolean,
    default: false,
  },
  favoriteId: {
    type: [Number, String],
    default: null,
  },
});

const emit = defineEmits(['shared', 'shareError', 'toggleFavorite', 'action']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard title="Ações de conversão" density="tight">
    <div class="grid gap-2">
      <ShareListingButton
        class="w-full"
        :url="reportLink"
        :title="imovel.titulo"
        variant="text"
        source="dashboard_detail"
        :business-context="businessContext"
        @shared="emit('shared', $event)"
        @error="emit('shareError', $event)"
      />
      <LaisFavoriteButton
        class="w-full"
        variant="text"
        :listing="imovel"
        :contact-id="contactId"
        position="pricebox"
        :business-context="businessContext"
        :initially-favorited="favorited"
        :initial-favorite-id="favoriteId"
        @toggle="emit('toggleFavorite', $event)"
      />
      <LaisListingCtaMatrix
        :listing="imovel"
        @action="emit('action', $event)"
      />
    </div>
    <p
      v-if="!contactId"
      class="mt-3 text-[12px] leading-relaxed text-lais-text-muted"
    >
      Para salvar favorito ou criar alerta, abra o imóvel a partir do histórico
      ou CRM de um cliente.
    </p>
  </LaisCard>
</template>
